import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=1598ebe3&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"
import style0 from "./tree.vue?vue&type=style&index=0&id=1598ebe3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1598ebe3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1598ebe3')) {
      api.createRecord('1598ebe3', component.options)
    } else {
      api.reload('1598ebe3', component.options)
    }
    module.hot.accept("./tree.vue?vue&type=template&id=1598ebe3&scoped=true", function () {
      api.rerender('1598ebe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/consume/components/tree.vue"
export default component.exports